import { useIntl } from "react-intl";
import { SimpleEntityGridColumn } from "src/app/components/grid/SimpleEntityGrid";
import { CellTags } from "src/app/components";
import { dateComparator } from "src/app/utils/aggrid/infinityLoadHelper";
import moment from "moment";

export default function useTitleIAGridColumns() {
    const { formatMessage } = useIntl();
    const gridColumns: Array<SimpleEntityGridColumn> = [
        {
            field: "createdAt",
            minWidth: 130,
            maxWidth: 130,
            filter: "agDateColumnFilter",
            headerName: formatMessage({ id: "content.grid.col.createdAt" }),
            comparator: dateComparator,
            valueFormatter: ({ data }: any) =>
                data.createdAt ? moment(data.createdAt).format("DD/MM/YY") : "N/A",
            valueGetter: ({ data }: any) =>
                data.createdAt ? `${moment(data.createdAt).format("DD/MM/YYYY HH:mm:ss")}` : "N/A",
        },
        {
            field: "rd.domain",
            filter: "agTextColumnFilter",
            headerName: formatMessage({ id: "content.grid.col.publishedOn" }),
        },
        {
            field: "content.title",
            filter: "agTextColumnFilter",
            headerName: formatMessage({ id: "content.grid.col.title" }),
        },
        {
            field: "keyword",
            autoHeight: true,
            filter: "agTextColumnFilter",
            headerName: formatMessage({ id: "content.grid.col.keyword" }),
            valueGetter: ({ data }: any) => data?.keywords,
            cellRenderer: ({ data }: any) => <CellTags tags={data?.keywords} />,
        },
    ];

    return gridColumns;
}
